<template>
  <div class="modal-about">
    <div class="header-imgs">
      <img
        src="@/assets/headers-modals/about.svg"
        alt="Imagem header modal"
      >

      <img
        src="@/assets/icons/close.svg"
        alt="Botão de fechar"
        class="button-close"
        @click="close"
      >
    </div>
    <h2>Meus contatos</h2>

    <div class="user-info">
      <img
        src="@/assets/icons/location.svg"
        alt="Ìcone de localização"
        class="icon-user-info"
      >

      <div>
        <label for="location">Cidade</label>
        <input
          id="location"
          v-model="updateUser.location"
          :placeholder="resume.location"
          type="text"
          name="location"
        >
      </div>
    </div>

    <div class="user-info">
      <img
        src="@/assets/icons/phone.svg"
        alt="Ìcone de telefone"
        class="icon-user-info"
      >
      <div>
        <label for="tel">Telefone</label>
        <input
          id="tel"
          v-model="updateUser.phone"
          :placeholder="resume.phone"
          type="text"
          name="tel"
        >
      </div>
    </div>

    <div class="user-info">
      <img
        src="@/assets/icons/social-media/facebook.svg"
        alt="Ìcone de telefone"
        class="icon-user-info"
      >
      <div>
        <label for="facebook">Facebook</label>
        <input
          id="facebook"
          v-model="updateUser.facebook"
          :placeholder="resume.facebook"
          type="text"
          name="facebook"
        >
      </div>
    </div>

    <div class="user-info">
      <img
        src="@/assets/icons/social-media/linkedin.svg"
        alt="Ìcone de telefone"
        class="icon-user-info"
      >
      <div>
        <label for="linkedin">Linkedin</label>
        <input
          id="linkedin"
          v-model="updateUser.linkedin"
          :placeholder="resume.linkedin"
          type="text"
          name="linkedin"
        >
      </div>
    </div>

    <div class="user-info">
      <img
        src="@/assets/icons/social-media/twitter.svg"
        alt="Ìcone de telefone"
        class="icon-user-info"
      >
      <div>
        <label for="twitter">Twitter</label>
        <input
          id="twitter"
          v-model="updateUser.twitter"
          :placeholder="resume.twitter"
          type="text"
          name="twitter"
        >
      </div>
    </div>

    <div class="footer">
      <button
        class="cancelar"
        @click="close"
      >
        Cancelar
      </button>
      <button
        class="confirmar"
        @click="updateSubmit"
      >
        Atualizar
      </button>
    </div>
  </div>
</template>


<script>

import { mapGetters, mapActions } from "vuex"

export default {
    name: "About",

    data() {
      return {
        updateUser: {
          location: '',
          phone: '',
          facebook: '',
          linkedin: '',
          twitter: ''
        }
      }
    },

    computed: {
      ...mapGetters('auth', ['resume'])
    },

    methods: {
      ...mapActions('auth', ['update']),

      close() {
        this.$emit('close')
      },

      async updateSubmit() {
        // eslint-disable-next-line no-unused-vars
        let payload = Object.fromEntries(Object.entries(this.updateUser).filter(([_, v]) => v != null && v != ''));

        await this.update(payload)

        this.close()
      }
    }
}

</script>


<style lang="scss" scoped>

.modal-about {
  padding: 40px 40px 30px 40px;

  .header-imgs {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .button-close {
      cursor: pointer;
    }
  }
  
  h2 {
    color: #66788A;
    font-weight: 700;
    font-size: 2rem;
    margin-bottom: 20px;
  }

  .user-info {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(228, 231, 235, 1);

    .icon-user-info {
      border: 1px solid rgba(199, 206, 212, 1);
      border-radius: 4px;
      padding: 16px;
      margin-right: 20px;
    }

    label {
      display: block;
      font-family: 'Roboto 500';
      color: rgba(102, 120, 138, 1);
      font-size: 16px;
      margin-bottom: 5px;
    }

    input {
      display: block;
      font-family: 'Roboto', sans-serif;
      color: rgba(158, 160, 165, 1);
      padding: 8px 8px;
      border: 1px solid rgba(199, 206, 212, 1);
      border-radius: 4px;
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;

    button {
      border-radius: 4px;
      font-size: 1.25rem;
      font-weight: 500;
      width: 45%;
      padding: 8px 0;
      cursor: pointer;

      &.cancelar {
        border: 2px solid #D3D3D3;
        background: #FFFFFF;
        color: #8B8B8B;
      }

      &.confirmar {
        border: 2px solid #1D43FF;
        background: #1D43FF;
        color: #fff;
      }
    }
  }
}
@media (max-width: 768px) {
  .modal-about {
    padding: 20px;

    .footer {
      display: block;
      
      button {
        border-radius: 4px;
        font-size: 1.25rem;
        font-weight: 500;
        width: 100%;
        padding: 13px 0;
        display: block;

        &.cancelar {
          border: 2px solid #D3D3D3;
          background: #FFFFFF;
          color: #8B8B8B;
          margin-bottom: 10px;
        }

        &.confirmar {
          border: 2px solid #1D43FF;
          background: #1D43FF;
          color: #fff;
        }
      }
    }
  }
}
</style>